module.exports = __webpack_public_path__ + "media/brands/innocenti-0cf15863.png";